// Shared filter types and constants for PLDataverseManager

export type FieldType = "string" | "number" | "boolean" | "date";

export const OPERATORS: Record<FieldType, string[]> = {
  string: [
    "eq",
    "neq",
    "contains",
    "startsWith",
    "endsWith",
    "containsdata",
    "doesnotcontaindata"
  ],
  number: [
    "eq",
    "neq",
    "gt",
    "gte",
    "lt",
    "lte",
    "containsdata",
    "doesnotcontaindata"
  ],
  boolean: [
    "eq",
    "neq",
    "containsdata",
    "doesnotcontaindata"
  ],
  date: [
    "eq",
    "neq",
    "before",
    "after",
    "onOrBefore",
    "onOrAfter",
    "containsdata",
    "doesnotcontaindata"
  ]
};

export interface FilterCondition {
  field: string;
  operator: string;
  value: string | number | boolean;
}

export interface FilterObject {
  and: FilterCondition[];
}